import { ReactChild } from 'react';
import cn from 'classnames';
import styles from './PlanButton.module.css';
import { PaymentPlanStatus, Plan } from '../Dashboard.types';
import { Button, Icon } from '@iwoca/orion';
import { useMediaQuery } from '../../../../customHooks/useMediaQuery';

const PlanButton = ({
    status,
    selectedPlanId,
    paymentPlan,
    selectPaymentPlan,
    children,
    renderContent
}: {
    status: PaymentPlanStatus | null;
    selectedPlanId: string | null;
    paymentPlan: Plan;
    selectPaymentPlan: (plan: Plan) => void;
    children: ReactChild;
    renderContent?: () => React.ReactNode;
}) => {
    const isMobile = useMediaQuery('(max-width: 1023px)');
    const isSelected = selectedPlanId === paymentPlan!.pay_link_id;

    return (
        <>
            <button
                className={cn(styles.paymentButton, {
                    [styles.active]:
                        selectedPlanId === paymentPlan!.pay_link_id,
                    [styles.paymentOverdue]: status === 'overdue'
                })}
                onClick={() => {
                    if (paymentPlan?.pay_link_id === selectedPlanId) {
                        selectPaymentPlan(null);
                    } else {
                        selectPaymentPlan(paymentPlan);
                    }
                }}
            >
                {children}
            </button>
            {isMobile && isSelected && renderContent && (
                <section className={styles.expandableContent}>
                    {renderContent()}
                    <Button
                        variant="tertiary"
                        className={styles.hideBtn}
                        onClick={() => selectPaymentPlan(null)}
                    >
                        Hide details <Icon icon="angleUp" />
                    </Button>
                </section>
            )}
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default PlanButton;
